import { SVGProps, Ref, forwardRef } from 'react';

export const BanFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.298 4.57C1.658 6.617 1 9.31 1 12c0 5.5 2.75 11 11 11 3.301 0 5.722-.88 7.438-2.29zm1.264-1.28 16.14 16.14C22.342 17.383 23 14.69 23 12c0-5.5-2.75-11-11-11-3.301 0-5.722.88-7.438 2.29"
                fill="currentColor"
            />
        </g>
    </svg>
));
BanFilledSize24Glyph.displayName = 'BanFilledSize24Glyph';
